export class AppConstants {
    public static get GetMenu(): any { return this.MENU };

  private static MENU = [ // Menu principal de la aplicacion
    {
      Name: 'Inicio',
      Route: 'home',
      Icon: 'fa-home',
      Children: [],
      Selected: true,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
    {
      Name: 'Buscar',
      Route: '',
      Icon: 'fa fa-search menu-icon parent-icon',
      Children: [
        {
          Name: 'Cliente',
          Route: '/search/bplog',
          Icon: 'fa fa-users subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Compañía',
          Route: '/search/companylog',
          Icon: 'fa fa-building',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Proveedores',
          Route: '/search/supplierlog',
          Icon: 'fa fa-users',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
      ],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
    {
      Name: 'Preferencias',
      Route: '',
      Icon: 'fa fa-cog title parent-icon',
      Children: [
        {
          Name: 'Alertas',
          Route: '/config/Alert',
          Icon: 'fa fa-bell subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Compañías',
          Route: '/config/Company',
          Icon: 'fa fa-building subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Alerta por Compañía',
          Route: '/config/AssingAlertToCompany',
          Icon: 'fa fa-plus subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Gestor',
          Route: '/config/Manager',
          Icon: 'fa fa-user subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
        {
          Name: 'Gestor por Compañía',
          Route: '/config/ManagerByCompany',
          Icon: 'fa fa-sort-amount-asc subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: '',
          Visible: true
        },
      ],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
    {
      Name: 'Salir',
      Route: '',
      Icon: 'fa fa-sign-out fa-lg title parent-icon',
      Children: [],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
  ];
}

export const WeekDays = [
    {id: 1, name: 'Do', checked: false},
    {id: 2, name: 'Lu', checked: false},
    {id: 3, name: 'Ma', checked: false},
    {id: 4, name: 'Mi', checked: false},
    {id: 5, name: 'Ju', checked: false},
    {id: 6, name: 'Vi', checked: false},
    {id: 7, name: 'Sa', checked: false},
]

export  const statusLog = [
    { key: '0', value: 'Todos' },
    { key: '1', value: 'Pendiente' },
    { key: '2', value: 'Enviando' },
    { key: '3', value: 'Enviado' },
    { key: '4', value: 'Error' }
  ];

 export enum sendTypes {
    SinSeleccion = '',
    RangoPorFecha = '1',
    Todos = '2',
    PorProveedor = '3'
  };